export default {
  create_team: {
    key: 'create_team',
    steps: [
      {
        target: '.create-team-header-item-wrapper',
        title: 'How it works?',
        content:
          'You will be given 100 Credits create your best 11 with this credits. You can choose max of 7 players from a team',
        isFixed: false,
        placement: 'auto',
        disableBeacon: true
      },
      {
        target: '.create-team-header-tab-item-container',
        title: 'Selection Criteria',
        content: 'You can select maximum of 4 Wicketkeepers, 6 Batsmans, 4 Allrounders, 6 Bowlers',
        isFixed: false,
        placement: 'auto',
        disableBeacon: true
      },
      {
        target: '.add_remove_player_btn',
        title: 'How to add a player?',
        content:
          'You can select or deselect a player from your team by toggling this select/deselect button',
        isFixed: false,
        placement: 'auto',
        disableBeacon: true,
        margin: '1px 0px 0px 0px'
      },
      {
        target: '.create-team-priview-btn',
        title: 'Team Preview',
        content: 'You can explore your Team by visiting here.',
        isFixed: false,
        placement: 'auto',
        disableBeacon: true,
        margin: '0px 0px 10px 0px'
      },

      {
        target: '.create-team-save-btn',
        title: 'Choose Captain , Vice captain',
        content:
          'Once done picking your team click on continue to proceed to select Captain & Vice captain of your team',
        isFixed: false,
        placement: 'auto',
        disableBeacon: true,
        margin: '0px 0px 10px 0px'
      }
    ]
  },

  create_team_mWeb: {
    key: 'create_team_mWeb',
    steps: [
      {
        target: '.create-team-header-item-wrapper_mWeb',
        title: 'How it works?',
        content:
          'You will be given 100 Credits create your best 11 with this credits. You can choose max of 7 players from a team',
        isFixed: false,
        placement: 'auto',
        disableBeacon: true
      },
      {
        target: '.create_team_tab_bar_contianer_mWeb',
        title: 'Selection Criteria',
        content: 'You can select maximum of 4 Wicketkeepers, 6 Batsmans, 4 Allrounders, 6 Bowlers',
        isFixed: false,
        placement: 'auto',
        disableBeacon: true
      },

      // {
      //   target: '.create-team-player-add-remove-button_mWeb',
      //   title: 'How to add a player?',
      //   content:
      //     'You can select or deselect a player from your team by toggling this select/deselect button',
      //   isFixed: false,
      //   placement: 'auto',
      //   disableBeacon: true,
      //   margin: '10px 0px 0px 0px'
      // },
      {
        target: '.create-team-preview-bottom-button_mWeb',
        title: 'Team Preview',
        content: 'You can explore your Team by visiting here.',
        isFixed: false,
        placement: 'auto',
        disableBeacon: true,
        margin: '5px 0px 0px',
        height: '50px'
        /* padding: 32px; */
      },
      {
        target: '.create-team-continue-bottom-button_mWeb',
        title: 'Choose Captain , Vice captain',
        content:
          'Once done picking your team click on continue to proceed to select Captain & Vice captain of your team',
        isFixed: false,
        placement: 'auto',
        disableBeacon: true,
        margin: '5px 0px 0px',
        /* padding: 32px; */
        height: '50px'
      }
    ]
  },

  create_team_football: {
    key: 'create_team_football',
    steps: [
      {
        target: '.create-team-header-item-wrapper',
        title: 'How it works?',
        content:
          'You will be given 100 Credits create your best 11 with this credits. You can choose max of 7 players from a team',
        isFixed: false,
        placement: 'auto',
        disableBeacon: true
      },
      {
        target: '.create-team-header-tab-item-container',
        title: 'Selection Criteria',
        content: 'You can select maximum of 1 Goalkeeper, 5 Defenders, 5 Midfielders, 3 Strikers',
        isFixed: false,
        placement: 'auto',
        disableBeacon: true
      },
      {
        target: '.add_remove_player_btn',
        title: 'How to add a player?',
        content:
          'You can select or deselect a player from your team by toggling this select/deselect button',
        isFixed: false,
        placement: 'auto',
        disableBeacon: true,
        margin: '1px 0px 0px 0px'
      },
      {
        target: '.create-team-priview-btn',
        title: 'Team Preview',
        content: 'You can explore your Team by visiting here.',
        isFixed: false,
        placement: 'auto',
        disableBeacon: true,
        margin: '0px 0px 10px 0px'
      },

      {
        target: '.create-team-save-btn',
        title: 'Choose Captain , Vice captain',
        content:
          'Once done picking your team click on continue to proceed to select Captain & Vice captain of your team',
        isFixed: false,
        placement: 'auto',
        disableBeacon: true,
        margin: '0px 0px 10px 0px'
      }
    ]
  },

  create_team_football_mWeb: {
    key: 'create_team_football_mWeb',
    steps: [
      {
        target: '.create-team-header-item-wrapper_mWeb',
        title: 'How it works?',
        content:
          'You will be given 100 Credits create your best 11 with this credits. You can choose max of 7 players from a team',
        isFixed: false,
        placement: 'auto',
        disableBeacon: true
      },
      {
        target: '.create_team_tab_bar_contianer_mWeb',
        title: 'Selection Criteria',
        content: 'You can select maximum of 1 Goalkeeper, 5 Defenders, 5 Midfielders, 3 Strikers',
        isFixed: false,
        placement: 'auto',
        disableBeacon: true
      },

      // {
      //   target: '.create-team-player-add-remove-button_mWeb',
      //   title: 'How to add a player?',
      //   content:
      //     'You can select or deselect a player from your team by toggling this select/deselect button',
      //   isFixed: false,
      //   placement: 'auto',
      //   disableBeacon: true,
      //   margin: '10px 0px 0px 0px'
      // },
      {
        target: '.create-team-preview-bottom-button_mWeb',
        title: 'Team Preview',
        content: 'You can explore your Team by visiting here.',
        isFixed: false,
        placement: 'auto',
        disableBeacon: true,
        margin: '5px 0px 0px',
        height: '50px'
        /* padding: 32px; */
      },
      {
        target: '.create-team-continue-bottom-button_mWeb',
        title: 'Choose Captain , Vice captain',
        content:
          'Once done picking your team click on continue to proceed to select Captain & Vice captain of your team',
        isFixed: false,
        placement: 'auto',
        disableBeacon: true,
        margin: '5px 0px 0px',
        /* padding: 32px; */
        height: '50px'
      }
    ]
  },

  choose_captain_vice_captain_cricket: {
    key: 'choose_captain_vice_captain_cricket',
    steps: [
      {
        target: '.choose_captain_vice_captain_points_name_container',
        title: 'How Point Systems Works?',
        content:
          'Selecting a player as captain and vicecaptain will boost the points you score if they play exceptionally. A 2* boost for captain & 1.5* boost for vicecaptain will be given',
        isFixed: false,
        placement: 'auto',
        disableBeacon: true
      },
      {
        target: '.choose_captain_vc_player_list_container',
        title: 'How to select?',
        content:
          'Select a player from the list as your captain or vice captain from the list by toggling between options',
        isFixed: false,
        placement: 'auto',
        disableBeacon: true
      },
      {
        target: '.choose_captain_save_btn',
        title: 'Saving your team',
        content: 'After selecting captain & vicecaptain click here to save your team',
        isFixed: false,
        placement: 'auto',
        disableBeacon: true
      }
    ]
  },
  choose_captain_vice_captain_cricket_mWeb: {
    key: 'choose_captain_vice_captain_cricket_mWeb',
    steps: [
      {
        target: '.choose-captain-header-container_mWeb',
        title: 'How Point Systems Works?',
        content:
          'Selecting a player as captain and vicecaptain will boost the points you score if they play exceptionally. A 2* boost for captain & 1.5* boost for vicecaptain will be given',
        isFixed: false,
        placement: 'auto',
        disableBeacon: true
      },
      {
        target: '.choose-captain-list-container_mWeb',
        title: 'How to select?',
        content:
          'Select a player from the list as your captain or vice captain from the list by toggling between options',
        isFixed: false,
        placement: 'auto',
        disableBeacon: true
      },
      {
        target: '.choose-captain-button_mWeb',
        title: 'Saving your team',
        content: 'After selecting captain & vicecaptain click here to save your team',
        isFixed: false,
        placement: 'auto',
        disableBeacon: true
      }
    ]
  },
  home_page: {
    key: 'home_page',
    steps: [
      {
        target: '.avatar_web',
        title: 'My Profile',
        content: 'You can explore your profile details by visiting here',
        isFixed: false,
        placement: 'auto',
        disableBeacon: true
      },
      {
        target: '.games_poster_wrapper',
        title: 'Play Games Win Big',
        content: 'Choose from a number of games, and win big',
        isFixed: false,
        placement: 'auto',
        disableBeacon: true
      },

      {
        target: '.balance-wrapper_web',
        title: 'My Wallet?',
        content: 'You can see your wallet balance here',
        isFixed: false,
        placement: 'auto',
        disableBeacon: true
      },
      {
        target: '.dailyRewards__img__web',
        title: 'Daily Rewards',
        content: ' Play and win daily by Completing challenges',
        isFixed: false,
        placement: 'auto',
        disableBeacon: true
      }
    ]
  },
  home_page_mWeb: {
    key: 'home_page_mWeb',
    steps: [
      {
        target: '.header_user_welcome_mWeb',
        title: 'My Profile',
        content: 'You can explore your profile details by visiting here',
        isFixed: false,
        placement: 'auto',
        disableBeacon: true,
        margin: '8px 0px 0px 15px'
      },
      {
        target: '.games_poster_wrapper_mWeb',
        title: 'Play Games Win Big',
        content: 'Choose from a number of games, and win big',
        isFixed: false,
        placement: 'auto',
        disableBeacon: true
      },

      {
        target: '.header_user_info_wrapper_mWeb',
        title: 'My Wallet?',
        content: 'You can see your wallet balance here',
        isFixed: false,
        placement: 'auto',
        disableBeacon: true
      },
      {
        target: '.dailyRewards__img__mWeb',
        title: 'Daily Rewards',
        content: ' Play and win daily by Completing challenges',
        isFixed: false,
        placement: 'auto',
        disableBeacon: true
      }
    ]
  }
} as any;
